import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

const BlankSlate = props => {
  const styleName = classNames(props.className, 'NewBlankSlate', {
    'NewBlankSlate--large': props.large,
    'NewBlankSlate--extraLarge': props.extraLarge,
    'NewBlankSlate--simple': props.simple,
    'NewBlankSlate--leftAlign': props.align === 'left',
    'NewBlankSlate--dashedBorder': props.borderStyle === 'dashed',
    'NewBlankSlate--fullWidth': props.fullWidth,
  });
  return (
    <div className={styleName}>
      {props.icon && props.simple && (
        <Icon name={props.icon} className="NewBlankSlate-icon" />
      )}
      {props.children}
    </div>
  );
};

export default BlankSlate;
